import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>WINNING RESOURCES
                                            </div>
                                            <p>You’ll need to show that you’ve given careful, objective thought
                                                to why the success of your project
                                                requires the resources you’re asking for. Give timescales for
                                                each stage as well as its overall
                                                completion and, importantly, describe the benefits it will
                                                deliver. You’ll need negotiating and
                                                influencing skills:</p>
                                            <div className="border_subtitle">Interpersonal awareness</div>
                                            <p>What concerns might other people have about you winning the
                                                resources you’re requesting? If
                                                it’s money, is it wanted elsewhere? Try to find out information
                                                like this so that you can argue your
                                                case with some insight into what resistance you might encounter.
                                                If there’s a general, financial
                                                concern, highlight how your project could improve productivity
                                                or bring other opportunities.</p>
                                            <div className="border_subtitle">Bargaining</div>
                                            <p>Negotiate a mutually beneficial outcome. If you know that someone
                                                else wants the same
                                                resources, try to agree a compromise. You may want someone with
                                                expertise from another team,
                                                which would leave it short staffed, so offer a replacement from
                                                your own team. Compromise on
                                                the less important issues to gain bargaining power for other
                                                issues!</p>
                                            <div className="border_subtitle">Relationships</div>
                                            <p>Building rapport with others can help win their support when you
                                                need it. Show interest in their
                                                work and concerns and offer solutions where appropriate.</p>
                                            <div className="border_subtitle">Buy-in</div>
                                            <p>To gain commitment from key decision makers, build their interest
                                                and involvement by
                                                demonstrating the practicality and benefit of your ideas.
                                                (There’s more information about this in
                                                the tool: ‘How to gain buy-in and commitment’.)</p>
                                            <div className="border_subtitle">Organisational values</div>
                                            <p>Show how your project aligns with the organisation’s goals and
                                                objectives. The most persuasive
                                                argument for any organisation is one which positively impacts
                                                the bottom line!</p>
                                            <div className="border_subtitle">Facts</div>
                                            <p>Use facts and other information to support your business case. If
                                                you can, calculate the likely
                                                return on investment in your project – and the current, negative
                                                impact of any weaknesses your
                                                project might address.</p>
                                            <div className="border_subtitle">Negotiation</div>
                                            <p>Hopefully, your arguments will be sufficiently compelling to
                                                achieve the resources you want; if not
                                                there are three approaches that you could take:<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a></p>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <ol className="brownbullet-list">
                                                    <li><p>Request fewer resources or agree to a counter-request
                                                        that someone else wants.</p></li>
                                                    <li><p>Refuse to give someone else what they want unless
                                                        they give you something that
                                                        you need in return. However, it is better to push ahead
                                                        with strong arguments for
                                                        the resources you need.</p></li>
                                                    <li>
                                                        <div className="uiheading"><p>Team up and work with
                                                            others to find a mutually beneficial outcome.</p>
                                                        </div>
                                                    </li>
                                                </ol>
                                            </div>
                                            <p>To reach a mutually beneficial outcome, identify shared interests
                                                and goals to create a
                                                cooperative atmosphere.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}